import React from 'react';
import intl from 'react-intl-universal';
import { makeStyles, Box, Typography, Theme } from '@material-ui/core';
import { Button } from '@lifesize/clients.mui-components';
import { MainConsumer } from 'mainProvider';
import { radioButtonValues } from 'context';
import CallMeDirectly from 'components/CallMeDirectly';
import CircularProgress from 'components/CircularProgress';
import MeetingTypeForm from 'components/MeetingTypeForm';
import SearchMeetings from 'components/searchMeetings';
import SectionLabel from 'components/FormLabel';
import SearchRoomSystems from './searchRooms';

const ScheduleMeeting = () => {
  const classes = desktopStyles();
  return (
    <MainConsumer>
      {({ canSchedule, creatingAppointment, displayAppointmentForm, radioValue }) => {
        return (
          <Box pb={2}>
            <Typography data-testid="scheduleHeader" variant={'h1'}>
              {intl.get('scheduleMeeting')}
            </Typography>
            <Box pt={1} pb={4}>
              <Typography data-testid="scheduleSubTitle" variant={'subtitle2'}>
                {intl.get('inviteParticipants')}
              </Typography>
            </Box>
            <MeetingTypeForm
              legendLabel={`1. ${intl.get('chooseMeetingType')}`}
              formControlClass={classes.formControl}
            />
            <Box pt={4}>
              <SectionLabel label={`2. ${intl.get('addMeetingDetails')}`} />
            </Box>
            {radioValue === radioButtonValues.direct && <CallMeDirectly />}
            {radioValue === radioButtonValues.find && <SearchMeetings />}
            {radioValue === radioButtonValues.findRoom && <SearchRoomSystems />}
            <Box mt={4} className={classes.button}>
              <Button
                data-testid="scheduleBtn"
                color="primary"
                variant="contained"
                disabled={!canSchedule || creatingAppointment}
                onClick={() => displayAppointmentForm && displayAppointmentForm()}
              >
                {intl.get('schedule')}
              </Button>
              {creatingAppointment && <CircularProgress />}
            </Box>
          </Box>
        );
      }}
    </MainConsumer>
  );
};

const desktopStyles = makeStyles((theme: Theme) => ({
  formControl: {
    margin: theme.spacing(0),
    '& legend': {
      lineHeight: `${theme.spacing(3)}px`
    }
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative'
  }
}));

export default ScheduleMeeting;
